import React,{useEffect,useState} from 'react';
import './comp_cadet_record_book.css'

export const Comp_CRB_New=(props)=>{
    let _semCheck="";
    let _functionCheck="";
    let _divIndexNm="";
    useEffect(()=>{
        //alert(JSON.stringify(props.task_list));
    },[props.task_list]);
    
    return(
        <section>

        {/* div-1  */}
        <div class="saperate-page div1 text-start">
        <table>
            <td>
                
            </td>
        </table>
    </div>
        {/* div-2  */}
        
        <div class="saperate-page container-fluid div-2">
        <h5 class="text-center mb-3">INDEX</h5>
        
        <table class="main-table"  cellspacing="0" cellpadding="0">
            <tr>
                {/* <!-- Left Column --> */}
                <td>
                    <table class="content-table">
                        <tr class="section-header">
                            <td colspan="2">Section 1 - Introduction</td>
                        </tr>
                        <tr class="pink-row">
                            {/* <td class="page-col">Page no.</td> */}
                            <td>Content</td>
                        </tr>
                        <tr>
                            {/* <td>9-12</td> */}
                            <td>Section 1.1: Comment</td>
                        </tr>
                        <tr>
                            {/* <td>13</td> */}
                            <td>Section 1.2: Scope</td>
                        </tr>
                        <tr>
                            {/* <td>13-14</td> */}
                            <td>Section 1.3: Objectives</td>
                        </tr>
                        <tr>
                            {/* <td>14</td> */}
                            <td>Section 1.4: Completion Guidelines</td>
                        </tr>
                    </table>
                    
                    <table class="content-table mt-1">
                        <tr class="section-header">
                            <td colspan="2">Section 2 - Roles and Responsibilities</td>
                        </tr>
                        <tr class="pink-row">
                            {/* <td class="page-col">Page no.</td> */}
                            <td>Content</td>
                        </tr>
                        <tr>
                            {/* <td>15</td> */}
                            <td>Roles and Responsibilities</td>
                        </tr>
                    </table>
                    
                    <table class="content-table mt-1">
                        <tr class="section-header">
                            <td colspan="2">Section 3 - General Information</td>
                        </tr>
                        <tr class="pink-row">
                            {/* <td class="page-col">Page no.</td> */}
                            <td>Content</td>
                        </tr>
                        <tr>
                            {/* <td>16</td> */}
                            <td>Section 3.1: Cadet's Particulars</td>
                        </tr>
                        <tr>
                            {/* <td>17</td> */}
                            <td>Section 3.2: Educational Record</td>
                        </tr>
                        <tr>
                            {/* <td>18</td> */}
                            <td>Section 3.3: Professional Training Record</td>
                        </tr>
                        <tr>
                            {/* <td>19</td> */}
                            <td>Section 3.4: Sea Service Record</td>
                        </tr>
                    </table>
                    
                    <table class="content-table mt-1">
                        <tr class="section-header">
                            <td colspan="2">Section 4 - Task Progress Overview</td>
                        </tr>
                        <tr class="pink-row">
                            {/* <td class="page-col">Page no.</td> */}
                            <td>Content</td>
                        </tr>
                        <tr>
                            {/* <td>20-25</td> */}
                            <td>Section 4.1: Shipboard Training Officer's Monthly Review of the Activity Record</td>
                        </tr>
                        <tr>
                            {/* <td>26-31</td> */}
                            <td>Section 4.2: Master's Monthly Review of the Record Book</td>
                        </tr>
                        <tr>
                            {/* <td>32-33</td> */}
                            <td>Section 4.3: Company's/ Maritime Training Institute's Review of the Record Book</td>
                        </tr>
                        <tr>
                            {/* <td>34-49</td> */}
                            <td>Section 4.4: Task Summary Record</td>
                        </tr>
                        <tr>
                            {/* <td>50-55</td> */}
                            <td>Section 4.5: Video / CBT / UBT Activity Record</td>
                        </tr>
                    </table>
                    
                    <table class="content-table mt-1">
                        <tr class="section-header">
                            <td colspan="2">Section 5 - Shipboard Safety and Security Familiarization</td>
                        </tr>
                        <tr class="pink-row">
                            {/* <td class="page-col">Page no.</td> */}
                            <td>Content</td>
                        </tr>
                        <tr>
                            {/* <td>56-60</td> */}
                            <td>Shipboard Safety and Security Familiarization</td>
                        </tr>
                    </table>
                    
                    <table class="content-table mt-1">
                        <tr class="section-header">
                            <td colspan="2">Section 6 - Ship's Particulars</td>
                        </tr>
                        <tr class="pink-row">
                            {/* <td class="page-col">Page no.</td> */}
                            <td>Content</td>
                        </tr>
                        <tr>
                            {/* <td>61-66</td> */}
                            <td>Ship's Particulars</td>
                        </tr>
                    </table>
                </td>
                
                {/* <!-- Middle Column --> */}
                <td>
                    <table class="content-table">
                        <tr class="section-header">
                            <td colspan="2">Section 7: International Regulations for Preventing Collisions at Sea</td>
                        </tr>
                        <tr class="pink-row">
                            {/* <td class="page-col">Page no.</td> */}
                            <td>Content</td>
                        </tr>
                        <tr>
                            {/* <td>67-68</td> */}
                            <td>International Regulations for Preventing Collisions at Sea</td>
                        </tr>
                    </table>
                    
                    <table class="content-table mt-1">
                        <tr class="section-header">
                            <td colspan="2">Section 8 - Onboard Competence/ Tasks</td>
                        </tr>
                        <tr class="pink-row">
                            {/* <td class="page-col">Page no.</td> */}
                            <td>Content</td>
                        </tr>
                        <tr>
                            {/* <td>69-70</td> */}
                            <td>Section 8.1: Task Guidelines</td>
                        </tr>
                        <tr>
                            {/* <td>71-90</td> */}
                            <td>Section 8.2: Tasks for Navigation</td>
                        </tr>
                        <tr>
                            {/* <td>91-95</td> */}
                            <td>Section 8.3: Tasks for Cargo Handling and Stowage</td>
                        </tr>
                        <tr>
                            {/* <td>96-109</td> */}
                            <td>Section 8.4: Tasks for Controlling the Operation of the Ship and Care of Persons on Board including Ship Security</td>
                        </tr>
                        <tr>
                            {/* <td>110-113</td> */}
                            <td>Section 8.5: Additional Tasks for Cargo Operations (Tankers: General)</td>
                        </tr>
                        <tr>
                            {/* <td>114-117</td> */}
                            <td>Section 8.6: Additional Tasks for Cargo Operations (Oil Tankers)</td>
                        </tr>
                        <tr>
                            {/* <td>118-121</td> */}
                            <td>Section 8.7: Additional Tasks for Cargo Operations (Chemical Tankers)</td>
                        </tr>
                        <tr>
                            {/* <td>122-128</td> */}
                            <td>Section 8.8: Additional Tasks for Cargo Operations (Gas Carriers)</td>
                        </tr>
                        <tr>
                            {/* <td>129</td> */}
                            <td>Section 8.9: Additional Tasks for Shipboard Operations on Passenger Ships</td>
                        </tr>
                        <tr>
                            {/* <td>130</td> */}
                            <td>Section 8.10: Additional Tasks for Cargo Operations on Ro-Ro Ships</td>
                        </tr>
                        <tr>
                            {/* <td>131</td> */}
                            <td>Section 8.11: Additional Tasks for Ships Operating in Polar Waters/ Winter Conditions</td>
                        </tr>
                        <tr>
                            {/* <td>132</td> */}
                            <td>Section 8.12: Additional Tasks for Dynamic Positioning (DP) Vessels, Platform Supply Vessels (PSVs) and Offshore Supply Vessels</td>
                        </tr>
                    </table>
                </td>
                
                {/* <!-- Right Column --> */}
                <td>
                    <table class="content-table">
                        <tr class="section-header">
                            <td colspan="2">Section 9 - Record of Watchkeeping and Steering</td>
                        </tr>
                        <tr class="pink-row">
                            {/* <td class="page-col">Page no.</td> */}
                            <td>Content</td>
                        </tr>
                        <tr>
                            {/* <td>133</td> */}
                            <td>Section 9.1: Record of Watchkeeping</td>
                        </tr>
                        <tr>
                            {/* <td>135-140</td> */}
                            <td>Section 9.2: Record of Steering</td>
                        </tr>
                        <tr>
                            {/* <td>141</td> */}
                            <td>Section 9.3: Record of Port Watches</td>
                        </tr>
                        <tr>
                            {/* <td>142</td> */}
                            <td>Section 9.4: Record of Engine Room Watches</td>
                        </tr>
                        <tr>
                            {/* <td>143-148</td> */}
                            <td>Section 9.5: Bridge Watchkeeping Certificate</td>
                        </tr>
                        <tr>
                            {/* <td>149</td> */}
                            <td>Section 9.6: Steering Certificate</td>
                        </tr>
                        <tr>
                            {/* <td>150-155</td> */}
                            <td>Section 9.7: Port Watchkeeping Certificate</td>
                        </tr>
                        <tr>
                            {/* <td>156-161</td> */}
                            <td>Section 9.8: Engine Room Watchkeeping Certificate</td>
                        </tr>
                    </table>
                    
                    <table class="content-table mt-1">
                        <tr class="section-header">
                            <td colspan="2">Section 10 - Project Work</td>
                        </tr>
                        <tr class="pink-row">
                            {/* <td class="page-col">Page no.</td> */}
                            <td>Content</td>
                        </tr>
                        <tr>
                            {/* <td>162</td> */}
                            <td>Section 10.1: Projects - Navigation</td>
                        </tr>
                        <tr>
                            {/* <td>163</td> */}
                            <td>Section 10.2: Projects - Controlling the Operation of the Ship and Care for Persons on Board</td>
                        </tr>
                        <tr>
                            {/* <td>164</td> */}
                            <td>Section 10.3: Additional Projects for Container Vessels</td>
                        </tr>
                        <tr>
                            {/* <td>165</td> */}
                            <td>Section 10.4: Additional Projects for Bulk Carriers</td>
                        </tr>
                        <tr>
                            {/* <td>166</td> */}
                            <td>Section 10.5: Additional Projects for Oil and Product Tankers</td>
                        </tr>
                        <tr>
                            {/* <td>167</td> */}
                            <td>Section 10.6: Additional Projects for Gas Carriers</td>
                        </tr>
                        <tr>
                            {/* <td>168</td> */}
                            <td>Section 10.7: Additional Projects for Heavy Lift Vessels</td>
                        </tr>
                        <tr>
                            {/* <td>169</td> */}
                            <td>Section 10.8: Additional Projects for Car Carriers / Ro-Ro vessels</td>
                        </tr>
                        <tr>
                            {/* <td>170</td> */}
                            <td>Section 10.9: Additional Projects for Forest Product Carriers</td>
                        </tr>
                        <tr>
                            {/* <td>171</td> */}
                            <td>Section 10.10: Additional Projects for Offshore Vessels</td>
                        </tr>
                        <tr>
                            {/* <td>172-179</td> */}
                            <td>Section 11: Samples- Deck Cadet Shipboard Activity Workshop</td>
                        </tr>
                        <tr>
                            {/* <td>180</td> */}
                            <td>Section 12: Abbreviations</td>
                        </tr>
                    </table>
                </td>
            </tr>
        </table>
    </div>
        
        {/* div-3  */}

        <div class="saperate-page div-3 text-start">
        <table>
            <td>
                <h5>SECTION 1</h5>
                <h5>Introduction</h5>
                <h5>1.1 Comment </h5>
                <p>This Deck Cadet Structured Shipboard Training Programme Record Book attests to satisfactory completion of the tasks required for compliance with the
                    requirements of the International Convention on Standards of Training, Certification and Watchkeeping for Seafarers 1978, as amended in 2010 (STCW
                    2010).<br/>
                    The purpose of th~s programme is to help ensure that a Cadet is enabled to and makes the best use of the time at sea. It lists practical tasks required to be
                    carried out on board, in accordance with the STCW 2010 provisions relating to minimum standards of competence for officers, particularly in charge of a
                    navigational watch on ships of 500 gross tonnage or more (STCW 2010 -Code Table A-llll). It also lists the criteria for assessing the Cadet's progress.<br/>
    
                    The relevant roles and responsibilities of the Maritime Training Institution, Company Training Officer (CTO), Master, Sh~pboard Training Officer (STO) and the
                    Cadet Officer are defined in Section 2. Progress through the programme should be subject to close scrutiny by the Master, by the Cadet's designated
                    Shipboard Training Officer and the Company Training Officer. in instances where the Maritime Training lnstitution oversees the complete training period of
                    the cadet, namely the shore based and the shipboard training phases, the Maritime Training Institution shall assume the role of the Company Training Officer
                    (CTO).<br/>
                    Paragraph 6 'Onboard Training' of Section A-llllof STCW 2010 requires that every candidate for certification as officer in charge of a navigational watch on
                    ships of 500 gross tonnage or more whose seagoing service forms part of a training programme approved as meeting the requirements of that section shall
                    follow an approved programme of onboard training which: <br/>
                    ensures that, during the required period of seagoing service, the candidate receives systematic practical training and experience in the tasks, duties
                    and responsibilities of an officer in charge of a navigational watch, taking into account the guidance given in section 8-1111 of the STCW Code;
                    is closely supervised and monitored by qualified officers aboard the ships in which the approved seagoing service is performed; and
                    is adequately documented in a training record book or similar document<br/>
                    This Deck Cadet Structured Shipboard Training Programme Record Book is designed to meet the above requirements <br/>
                    The assessment method used is on board assessment by the Shipboard Training Officer (STO). The assessment tools are practical demonstration and oral
                    questioning by the STO. Oral questioning is a common assessment technique, which is not time consuming and responses to oral questions provide useful
                    evidence of a cadet's technical knowledge and understanding of shipboard procedures and safety requirements. The purpose is to discuss the relevant task
                    w~th the ST0 in order to obtain clarification, confirmation or supplementation as needed. 
                </p>
                <h5><b>1.2 Scope </b></h5>
                <p>
                    The scope of the practical training enables the Cadet to:<br/>
                    gain experience in relevant aspects of shipboard activities as they occur;<br/>
                    test and compare the knowledge acquired on campus with the daily practice on board;<br/>
                    consolidate and expand theoretical knowledge;<br/>
                    build a practical basis to achieve the standards of competence that accord with the relevant requirements of STCW 2010, Including with table A-Ill1 of
                    STCW 201 0;<br/>
                    build a practical basis to achieve the standards of competence in accordance with Regulation A-V11112 and the corresponding parts of the STCW
                    Code relating to the principles to be observed in keeping a navigational and port watch;<br/>
                    prepare for a future position on board.
                </p>
                <h5><b>1.3 Obiectives</b></h5>
                <p>The Cadet will acquire basic seamanship skills and a practical awareness of the need to follow safe working practices and also be able to keep a navigational
                    watch safely, in accordance with the relevant regulations and recommendations.<br/>
                    The objectives of the programme are to:<br/>
                    direct the practical training so that the Cadet is guided as to the objectives of the practical training period;<br/>
                    give guidance to the Master, Shipboard Training Officer and others regarding the tasks to be performed on board in order to achieve the desired
                    competences;<br/>
                    direct the Assessment Criteria so that the required training outcome can be reliably and fairly proved and documented. 
                </p>
                <h5><b>1.4 Completion Guidelines </b></h5>
                <p>
                   <p><b> On receiut of this book:</b></p>
                    The Cadet should complete the information required in Section 3 (General Information). The Cadet will be personally responsible for the safe keeping of this training
                    programme.
                    <p><b>As soon as possible after joining each ship:</b></p>
                    Section 5 concerning details of Shipboard Safety and Security Familiarization should be completed. An officer should sign to signify that mandatory familiarization as
                    required by the 2010 STCW Convention has been undertaken. <br/>
                    The Cadet should then complete Section 6 concerning the ship's particulars. The Shipboard Training Officer should provide an opportunity for this exercise to be
                    undertaken. <br/>
                    The Shipboard Training Officer should inspect the training programme to check progress. A plan can be formulated and opportunity given for the Cadet to tackle
                    competences that still need to be demonstrated. <br/>
                    <p><b>Throuahout the Cadet's seaaoina service:</b></p>
    
                    Section 8 containing the list of competences 1 tasks should be progressively completed. <br/>
                    The task summary record as shown in Section 4.4 should be Ised for recording the tasks completed In Section 8 and be kept updated. This summary record can be
                    used for planning and tackling the competences and tasks still to be demonstrated. <br/>
                    The training programme should be submitted to the Shipboard Training Officer on joining the ship and subsequently every month for inspection. The Shipboard Training
                    Officer's comments should be recorded and dated in Section 4.1. Comments should only'relate to the Cadet's competence and practical progress in training. <br/>
                    The training programme should be submitted to the Master for inspection every month. The Master's comments should be recorded, dated and stamped in Section 4.2.
                    Comments should only relate to the Cadet's competence and practical progress In training. <br/>
                    A precise record should be kept of the Cadet's seagoing service including time spent on steering, bridge watchkeeping duties and port and anchor watches. Please
                    refer to Section 9 for more details. <br/>
                    In addition to the practical training, the Cadet should improve understanding of the International Regulations for Preventing Collisions at Sea, as provided in Section 7,
                    and their implementation. <br/>
                    The Cadet is also required to do the project work as provided in Section 10. 
                </p>
                    
            </td>
        </table>
    </div>
        
        {/* div-4  */}
        
        <div class="saperate-page div-4  text-start">
    <table class="section2-table">
        <h5>SECTION 2</h5>
    <h5>Roles and Responsibilities</h5>
    
    <p>The main roles and responsibilities of the personnel involved in the delivery of a structured shipboard training programme are:</p>
    
    <table>
        <tr>
            <th>Maritime Training Institution*</th>
            <th>Company Training Officer</th>
            <th>Master</th>
            <th>Shipboard Training Officer</th>
            <th>Cadet Officer</th>
        </tr>
        <tr>
            <td>Overall administration of the training programme including the pre-sea training period.</td>
            <td>Overall administration of the structured shipboard training programme.</td>
            <td>Provides the link between the Shipboard Training Officer and the Company Training Officer/ Maritime Training Institution ashore.</td>
            <td>Responsible for organizing the programme of practical training at sea.</td>
            <td>Diligently follows the training programme.</td>
        </tr>
        <tr>
            <td>Issues guidance as required and ensures that all concerned with the training programme play their parts.</td>
            <td>Issues guidance as required and ensures that all concerned with the training programme play their parts.</td>
            <td>Ensures that all concerned are effectively carrying out the training programme.</td>
            <td>Ensures in a supervisory capacity, that the training programme is properly maintained and all requirements fulfilled. Ensures that the time the Cadet spends on board is as useful as possible in terms of training and experience, and activities are consistent with the objectives of the training programme, the progress of training and the ship's operational constraints. Uses the assessment criteria on the right hand side of the page and if satisfied that the Cadet can perform the tasks without supervision, signs and dates the "considered proficient" column.</td>
            <td>Makes the most of the opportunities presented, within or outside working hours. Completes the tasks prescribed in the training programme to the best of ability, demonstrates the completion to the Shipboard Training Officer and obtains initialed approval.</td>
        </tr>
        <tr>
            <td>Monitors the progress of the Cadet. Checks and comments on the appraisal report sent by the Shipboard Training Officer.</td>
            <td>Monitors the progress of the Cadet. Checks and comments on the appraisal report sent by the Shipboard Training Officer.</td>
            <td>Inspects the training programme at monthly intervals and gives comments and suggestions for further improvement.</td>
            <td>Inspects the training programme at monthly intervals and gives comments/ suggestions for further improvement. Sends a quarterly appraisal report on the Cadet's performance.</td>
            <td>Keeps the training programme updated and available for scrutiny at all times.</td>
        </tr>
    </table>
    
    <p class="footnote">* In many administrations the pre-sea maritime training institution takes the responsibility of monitoring the SSTP Record Book and finally certifying that the entire training programme has been satisfactorily completed.</p>
    </table>
   </div>
    
    {/* div-5  */}

    <div class="saperate-page section3-table div-5 text-start">
        <h5>SECTION 3</h5>
        <h5>3.1: Cadet's Particulars</h5>
        
        <p>Particulars of Cadet to be completed by the Cadet in BLOCK letters:</p>
        
        <table class="form-table">
            <tr>
                <td>
                    <div class="form-field">
                        First Name: <input type="text"/>
                    </div>
                    <div class="form-field">
                        Middle Name: <input type="text"/>
                    </div>
                    <div class="form-field">
                        Last Name: <input type="text"/>
                    </div>
                </td>
            </tr>
            <tr>
                <td>
                    <div class="form-field">
                        Date of Birth: <input type="text"/>
                    </div>
                    <div class="form-field">
                        Place of Birth: <input type="text"/>
                    </div>
                </td>
            </tr>
            <tr>
                <td>
                    <div class="form-field">
                        Passport No.: <input type="text"/>
                    </div>
                    <div class="form-field">
                        CDC No.: <input type="text"/>
                    </div>
                    <div class="form-field">
                        INDOS No.: <input type="text"/>
                    </div>
                </td>
            </tr>
            <tr>
                <td>
                    <div>Home Address:</div>
                    <input type="text" class="long-field"/>
                    <input type="text" class="long-field"/>
                </td>
            </tr>
            <tr>
                <td>
                    <div class="form-field">
                        Phone: <input type="text"/>
                    </div>
                    <div class="form-field">
                        Fax: <input type="text"/>
                    </div>
                    <div class="form-field">
                        E-mail: <input type="text"/>
                    </div>
                </td>
            </tr>
            <tr>
                <td>
                    <div class="form-field">
                        Date Of Entry: <input type="text"/>
                    </div>
                    <div class="form-field">
                        Height: <input type="text" style={{width: '50px'}}/> cm.
                    </div>
                    <div class="form-field">
                        Weight: <input type="text" style={{width: '50px'}}/> Kg
                    </div>
                    <div class="form-field">
                        Blood Group: <input type="text"/>
                    </div>
                </td>
            </tr>
            <tr>
                <td>
                    <div>Distinguishing Marks: <input type="text" class="long-field"  style={{width: '70%'}}/></div>
                </td>
            </tr>
            <tr>
                <td>
                    <div>Sponsoring Company: <input type="text" class="long-field"  style={{width: '70%'}}/></div>
                </td>
            </tr>
            <tr>
                <td>
                    <div>Address: <input type="text" class="long-field"/></div>
                    <input type="text" class="long-field"/>
                </td>
            </tr>
            <tr>
                <td>
                    <div>Name, Address and Relationship of Next of Kin: <input type="text" class="long-field"  style={{width: '50%'}}/></div>
                    <input type="text" class="long-field"/>
                </td>
            </tr>
            <tr>
                <td>
                    <div class="form-field">
                        Phone: <input type="text"/>
                    </div>
                    <div class="form-field">
                        Fax: <input type="text"/>
                    </div>
                    <div class="form-field">
                        E-mail: <input type="text"/>
                    </div>
                </td>
            </tr>
        </table>
    </div>


 {/* div-6  */}
        
 <div class="div-6 saperate-page text-start">
        <h5>3.2 Educational Record</h5>
        
        <p><strong>GCE "O" level / Class X</strong></p>
        
        <div class="form-field">
            <span class="field-label">Name and address of the school:</span>
            <span class="input-line">&nbsp;</span>
        </div>
        
        <div class="form-field">
            <span class="field-label">Date certificate issued:</span>
            <span class="input-line">&nbsp;</span>
        </div>
        
        <table>
            <tr>
                <th>Subjects</th>
                <th>Grade/ Marks</th>
            </tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
        </table>
        
        <p><strong>GCE "A" level / Class XII</strong></p>
        
        <div class="form-field">
            <span class="field-label">Name and address of the school:</span>
            <span class="input-line">&nbsp;</span>
        </div>
        
        <div class="form-field">
            <span class="field-label">Date certificate issued:</span>
            <span class="input-line">&nbsp;</span>
        </div>
        
        <table>
            <tr>
                <th>Subjects</th>
                <th>Grade/ Marks</th>
            </tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
        </table>
    </div>

{/* div-7  */}

<div class="div-7 saperate-page text-start">
    <h5>3.3 Professional Training Record</h5>
    <div class="section-title">Cadet's Training Programme</div>
    
   
    <table>
        <tr>
            <th>Pre-Sea Training<br/>Name of the College</th>
            <th>Date (From)</th>
            <th>Date (To)</th>
        </tr>
        <tr class="empty-row"><td></td><td></td><td></td></tr>
    </table>
    
    
    <table>
        <tr>
            <th>On-Board Training<br/>Name of the Ship</th>
            <th>Date (From)</th>
            <th>Date (To)</th>
        </tr>
        <tr class="empty-row"><td></td><td></td><td></td></tr>
        <tr class="empty-row"><td></td><td></td><td></td></tr>
        <tr class="empty-row"><td></td><td></td><td></td></tr>
        <tr class="empty-row"><td></td><td></td><td></td></tr>
    </table>
    
   
    <div class="section-title">Basic Training as Required by STCW 2010- Section A-VI/1</div>
    <table>
        <tr>
            <th>Course</th>
            <th>Date</th>
            <th>Name of Institution</th>
            <th>Location</th>
            <th>Certificate number</th>
        </tr>
        <tr>
            <td>Personal Survival Techniques</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Fire prevention and Fire fighting</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Elementary First Aid</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Personal Safety and Social Responsibilities</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Security Training for persons with designated duties</td>
            <td></td><td></td><td></td><td></td>
        </tr>
    </table>
    
   
    <div class="section-title">Record of Other Professional Training</div>
    <table>
        <tr>
            <th>Course</th>
            <th>Date</th>
            <th>Name of Institution</th>
            <th>Location</th>
            <th>Certificate number</th>
        </tr>
        <tr>
            <td>Proficiency in Survival Craft & Rescue Boat</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Radar Observer Course</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Automatic Radar Plotting Aids</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Medical First Aid</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>GMDSS General Operator's Certificate</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Oil and Chemical Tanker Familiarization</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Gas Tanker Familiarization</td>
            <td></td><td></td><td></td><td></td>
        </tr>
    </table>
   </div>

{/* div-8  */}

<div class="div-8 saperate-page text-start">
        <div class="title">3.4 Record of Sea Service</div>
    
    <table>
        <thead>
            <tr>
                <th rowspan="2" class="ship-col">Ship</th>
                <th rowspan="2" class="imo-col">IMO Number</th>
                <th colspan="2" class="date-col">Date</th>
                <th colspan="2" class="time-header">Time spent on bridge watchkeeping duties</th>
                <th colspan="2" class="time-header">Voyage total seagoing service</th>
            </tr>
            <tr>
                <th>Signed on</th>
                <th>Signed off</th>
                <th>Months</th>
                <th>Days</th>
                <th>Months</th>
                <th>Days</th>
            </tr>
        </thead>
        <tbody>
            <tr class="empty-row">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
          
            
            <tr class="total-row">
                <td colspan="4">Total Time</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
        </tbody>
    </table>
    </div>

{/* div-9  */}


<div class="div-9 saperate-page text-start">
        <div class="section-title">SECTION 4</div>
        <div class="sub-title">4.1 Shipboard Training Officer's Monthly Review of the Record Book</div>
        <div class="instructions">
            Comments should only relate to the Cadet's practical progress in training and competence.<br/>
            (The first two rows give examples of monthly entries)
        </div>
        
        <table>
            <thead>
                <tr>
                    <th style={{width: '5%'}}></th>
                    <th style={{width: '15%'}}>Ship</th>
                    <th style={{width: '30%'}}>Comments</th>
                    <th style={{width: '20%'}}>Shipboard Training Officer's Name</th>
                    <th style={{width: '20%'}}>Shipboard Training Officer's Signature and Stamp</th>
                    <th style={{width: '10%'}}>Date</th>
                </tr>
            </thead>
            <tbody>
               
                <tr>
                    <td>1.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
              
            </tbody>
        </table>
    </div>

 {/* div-10  */}
 <div class="div-10 saperate-page text-start">
        <div class="header">
            <h2>4.2 Master's Monthly Review of the Record Book</h2>
        </div>
        
        <div class="instructions text-start">
            Comments should only relate to Cadet's practical progress in training and competence.<br/>
            (First two rows indicate examples of filling the monthly review)
        </div>
        
        <table>
            <thead>
                <tr>
                    <th width="5%"></th>
                    <th width="15%">Ship</th>
                    <th width="30%">Comments</th>
                    <th width="15%">Master's Name</th>
                    <th width="15%">Master's Signature</th>
                    <th width="10%">Date</th>
                    <th width="15%">Ship's Official Stamp</th>
                </tr>
            </thead>
            <tbody>
               
                <tr>
                    <td>1.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                
            </tbody>
        </table>
        
    </div>

{/* div-11  */}
<div class="div11 saperate-page text-start">
    <h6>4.3 Company's/ Maritime Training Institution’s Review of the Record Book</h6>
    <p class="note">Comments should only relate to the Cadet’s practical progress in training and competence.</p>

    <table>
        <thead>
            <tr>
                <th>Comments</th>
                <th>Name</th>
                <th>Designation</th>
                <th>Signature</th>
                <th>Date</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td style={{height: '50px'}}></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
         
        </tbody>
    </table>

   
</div>

{/* div-12  */}
<div class="div-12 saperate-page text-start">
<h6>4.4 Task Summary Record</h6>
<p>The purpose of this summary record is to provide a continuous check on the status of the tasks. The Cadet should tick the tasks successfully completed. The
wlor wde for the tasks is:<br/>
Semester 3: Yellow<br/>
Semester 4: Green<br/>
Semester 5: Blue<br/>
Each phase is of 6 months. There is no colour codlng for specialized ships as the tasks on such ships are not segregated into phases.
The task summary record should be used for recording the tasks completed in Section 8 and be kept updated. In the boxes below the task number, tick off
those tasks which are completed and signed by the ST0 (In section 8).<br/>
Every quarter, the cadet needs to make a photocopy of all the Task Summary sheets (4.4.8 Summarv Record of all taskg). He shall then get these
photowp~ed Summary sheets signed, dated, stamped and attested by the STO. These may then be sent by post or a scanned oopy by email to the Company
Training Officer (CTO) who in turn will pass it to his Pre-Sea Maritime Training Institute.<br/>
Specimen signatures of all officers who have signed on this record book should be documented in the table below. 
</p>
</div>

{/* div-13  */}
<div class="div-13 saperate-page text-start">
<h5>4.4 A Record of Specimen signatures </h5>
<table>
        
        <thead>
            <tr>
                <th>Vessel Name</th>
                <th>Name of Officer</th>
                <th>Rank</th>
                <th>Specimen Signature</th>
                <th>Date Signed On</th>
                <th>Date Signed Off</th>
            </tr>
        </thead>
        <tbody>
 
            <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
            
        </tbody>
    </table>
</div>


{/* div-14  */}
<div class="div-14 saperate-page text-start">
    <h5 class="text start">TASK SUMMARY RECORD</h5>

    {props.task_list.map((m_item,m_index)=>{
        
        let semCheck=m_item["top_cats"].split('>');
        let divClass="div_"+semCheck[0];
        if(_semCheck!==semCheck[0]){
            _divIndexNm=divClass;
        }
      //alert(semCheck[0]+" == "+_semCheck);
        return <div class={_divIndexNm+" text-start"}>
<h5 class="text start">{_semCheck!==semCheck[0]?semCheck[0]:''}</h5>
    <h6 class="text start">{_functionCheck!==semCheck[1]?semCheck[1]:''}</h6>
    <div class={"text start"}>
        <table class="table11">
            <tbody>
                {props.task_list.map((item,index)=>{
                    
if(semCheck.length>=2){
    if(_semCheck!==semCheck[0]){
        _semCheck=semCheck[0];
    }
    if(_functionCheck!==semCheck[1]){
        _functionCheck=semCheck[1];
    }
    
}

if(m_item["top_cats"]===item["top_cats"]){
    let subTasks=JSON.parse(item["subtasks"]);
    return <tr>
        <td style={{"width":"50%"}}>{item["category_name"]}</td>
        <td>
            {subTasks.map((subItem,subIndex)=>{
                let taskNos=subItem["study_m_sub_task_nos"].split(',');
                return <>{
                
                taskNos.map((taskNos,taskNosIndex)=>{
                    return <span class="highlighted_task"><a class="chrf" chrf={"https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf="+btoa(subItem["study_m_id"])+"&rd_index=undefined"}>{taskNos}</a></span>
                })
            }</>
            })}
        </td>
    </tr>
}

                    
                  
                })}
            </tbody>
        </table>
    </div>
    </div>
        


    })}
    


   
    
   </div>



{/* div-15  */}

{/* div -16  */}


{/* div-17  */}
   <div class="div-17 saperate-page text-start">
        <div class="table-container">
            <div class="section-title text-start">
              Additional tasks (cargo operations) for tankers - general
            </div>
            <table>
              <tbody>
                <tr>
                  <td rowspan="8">E1- Contribute to the safe cargo operations</td>
                  <td>1.1.1</td>
                  <td>1.1.2</td>
                  <td>1.1.3</td>
                  <td>1.1.4</td>
                  <td>1.1.5</td>
                  <td>1.1.6</td>
                  <td>1.1.7</td>
                  <td>1.1.8</td>
                  <td>1.1.9</td>
                  <td>1.1.10</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>1.1.11</td>
                  <td>1.1.12</td>
                  <td>1.1.13</td>
                  <td>1.1.14</td>
                  <td>1.1.15</td>
                  <td>1.1.16</td>
                  <td>1.1.17</td>
                  <td>1.1.18</td>
                  <td>1.1.19</td>
                  <td>1.1.20</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>1.1.21</td>
                  <td>1.1.22</td>
                  <td>1.1.23</td>
                  <td>1.2.1</td>
                  <td>1.2.2</td>
                  <td>1.2.3</td>
                  <td>1.2.4</td>
                  <td>1.2.5</td>
                  <td>1.2.6</td>
                  <td>1.2.7</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>1.2.8</td>
                  <td>1.2.9</td>
                  <td>1.2.10</td>
                  <td>1.3.1</td>
                  <td>1.3.2</td>
                  <td>1.3.3</td>
                  <td>1.3.4</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
      
          <div class="table-container">
            <div class="section-title text-start">
              Additional tasks (cargo operations) for oil tankers
            </div>
            <table>
              <tbody>
                <tr>
                  <td rowspan="8">F1- Contribute to the safe cargo operations</td>
                  <td>1.1.1</td>
                  <td>1.1.2</td>
                  <td>1.1.3</td>
                  <td>1.1.4</td>
                  <td>1.1.5</td>
                  <td>1.1.6</td>
                  <td>1.1.7</td>
                  <td>1.1.8</td>
                  <td>1.1.9</td>
                  <td>1.1.10</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>1.1.11</td>
                  <td>1.1.12</td>
                  <td>1.1.13</td>
                  <td>1.1.14</td>
                  <td>1.1.15</td>
                  <td>1.1.16</td>
                  <td>1.1.17</td>
                  <td>1.1.18</td>
                  <td>1.1.19</td>
                  <td>1.1.20</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>1.1.21</td>
                  <td>1.1.22</td>
                  <td>1.1.23</td>
                  <td>1.1.24</td>
                  <td>1.1.25</td>
                  <td>1.1.26</td>
                  <td>1.1.27</td>
                  <td>1.1.28</td>
                  <td>1.1.29</td>
                  <td>1.1.30</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>1.1.31</td>
                  <td>1.1.32</td>
                  <td>1.1.33</td>
                  <td>1.2.1</td>
                  <td>1.2.2</td>
                  <td>1.2.3</td>
                  <td>1.2.4</td>
                  <td>1.3.1</td>
                  <td>1.3.2</td>
                  <td>1.3.3</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
      
          <div class="table-container">
            <div class="section-title text-start">
              Additional tasks (cargo operations) for chemical tankers
            </div>
            <table>
              <tbody>
                <tr>
                  <td rowspan="10">G1- Contribute to the safe cargo operations</td>
                  <td>1.1.1</td>
                  <td>1.1.2</td>
                  <td>1.1.3</td>
                  <td>1.1.4</td>
                  <td>1.1.5</td>
                  <td>1.1.6</td>
                  <td>1.1.7</td>
                  <td>1.1.8</td>
                  <td>1.1.9</td>
                  <td>1.1.10</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>1.1.11</td>
                  <td>1.1.12</td>
                  <td>1.1.13</td>
                  <td>1.1.14</td>
                  <td>1.1.15</td>
                  <td>1.1.16</td>
                  <td>1.1.17</td>
                  <td>1.1.18</td>
                  <td>1.1.19</td>
                  <td>1.1.20</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>1.1.21</td>
                  <td>1.1.22</td>
                  <td>1.1.23</td>
                  <td>1.1.24</td>
                  <td>1.1.25</td>
                  <td>1.1.26</td>
                  <td>1.1.27</td>
                  <td>1.1.28</td>
                  <td>1.1.29</td>
                  <td>1.1.30</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>1.2.1</td>
                  <td>1.2.2</td>
                  <td>1.2.3</td>
                  <td>1.2.4</td>
                  <td>1.2.5</td>
                  <td>1.2.6</td>
                  <td>1.2.7</td>
                  <td>1.2.8</td>
                  <td>1.2.9</td>
                  <td>1.2.10</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>1.2.11</td>
                  <td>1.2.12</td>
                  <td>1.3.1</td>
                  <td>1.3.2</td>
                  <td>1.3.3</td>
                  <td>1.3.4</td>
                  <td>1.3.5</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
    </div>

{/* div-18  */}
<div class="div-18 saperate-page text-start">
    <div class="table-container">
        <div class="section-title text-start">
          Additional tasks (cargo operations) for gas carriers
        </div>
        <table>
          <tbody>
            <tr>
              <td rowspan="16"> H1- Contribute to the safe cargo operation of a liquefied gas tanker and
                  have a basic knowledge of the physical properties of liquefied gases</td>
              <td>1.1.1</td>
              <td>1.1.2</td>
              <td>1.1.3</td>
              <td>1.1.4</td>
              <td>1.1.5</td>
              <td>1.1.6</td>
              <td>1.1.7</td>
              <td>1.1.8</td>
              <td>1.1.9</td>
              <td>1.1.10</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>1.1.11</td>
              <td>1.1.12</td>
              <td>1.1.13</td>
              <td>1.1.14</td>
              <td>1.1.15</td>
              <td>1.1.16</td>
              <td>1.1.17</td>
              <td>1.1.18</td>
              <td>1.1.19</td>
              <td>1.1.20</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>1.1.21</td>
              <td>1.1.22</td>
              <td>1.1.23</td>
              <td>1.1.24</td>
              <td>1.1.25</td>
              <td>1.1.26</td>
              <td>1.1.27</td>
              <td>1.1.28</td>
              <td>1.1.29</td>
              <td>1.1.30</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>1.1.31</td>
              <td>1.1.32</td>
              <td>1.1.33</td>
              <td>1.1.34</td>
              <td>1.1.35</td>
              <td>1.1.36</td>
              <td>1.1.37</td>
              <td>1.1.38</td>
              <td>1.1.39</td>
              <td>1.1.40</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>1.1.41</td>
              <td>1.1.42</td>
              <td>1.1.43</td>
              <td>1.1.44</td>
              <td>1.1.45</td>
              <td>1.1.46</td>
              <td>1.1.47</td>
              <td>1.1.48</td>
              <td>1.1.49</td>
              <td>1.1.50</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>1.1.51</td>
              <td>1.1.52</td>
              <td>1.1.53</td>
              <td>1.1.54</td>
              <td>1.1.55</td>
              <td>1.1.56</td>
              <td>1.1.57</td>
              <td>1.1.58</td>
              <td>1.1.59</td>
              <td>1.2.1</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>1.2.2</td>
              <td>1.2.3</td>
              <td>1.2.4</td>
              <td>1.2.5</td>
              <td>1.2.6</td>
              <td>1.2.7</td>
              <td>1.2.8</td>
              <td>1.2.9</td>
              <td>1.2.10</td>
              <td>1.2.11</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>1.3.1</td>
              <td>1.3.2</td>
              <td>1.3.3</td>
              <td>1.3.4</td>
              <td>1.3.5</td>
              <td>1.3.6</td>
              <td>1.3.7</td>
              <td>1.3.8</td>
              <td>1.3.9</td>
              <td>1.3.10</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
  
      <div class="table-container">
        <div class="section-title text-start">
          Additional tasks for shipboard operations on passenger ships
        </div>
        <table>
          <tbody>
            <tr>
              <td rowspan="2"> I 1- Control passengers and other personnel during emergency situations,
                  and establish and maintain effective communications</td>
              <td>1.1.1</td>
              <td>1.1.2</td>
              <td>1.1.3</td>
              <td>1.1.4</td>
              <td>1.1.5</td>
              <td>1.1.6</td>
              <td>1.1.7</td>
              <td>1.1.8</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-container">
        <div class="section-title text-start">
          Additional tasks for cargo operations on ro-ro ships
        </div>
        <table>
          <tbody>
            <tr>
              <td rowspan="2">J1- Contribute to the safe cargo operation of ro-ro ships with due
                  regard for safety of life at sea and protection of the marine
                  environment</td>
              <td>1.1.1</td>
              <td>1.1.2</td>
              <td>1.1.3</td>
              <td>1.1.4</td>
              <td>1.1.5</td>
              <td>1.1.6</td>
              <td>1.1.7</td>
              <td>1.1.8</td>
              <td>1.1.9</td>
              <td>1.1.10</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
  </div>

{/* div-19  */}
<div class="div-19 saperate-page text-start">
        <h6>Additional tasks for ships operating in polar waters/ winter conditions</h6>
    <table>
            <tr>
                <td rowspan="4">K1- Contribute to the safe operation of ships operating in polar waters and winter conditions with due regard for safety of life at sea and protection of the marine environment</td>
                <td>1.1.1</td>
                <td>1.1.2</td>
                <td>1.1.3</td>
                <td>1.1.4</td>
                <td>1.1.5</td>
                <td>1.1.6</td>
                <td>1.1.7</td>
                <td>1.1.8</td>
                <td>1.1.9</td>
                <td>1.1.10</td>
            </tr>
            <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td>1.1.11</td>
            </tr>
            <tr>
                <td></td>
            </tr>
    </table>

    <h6>Additional tasks for dynamic positioning (DP) vessels</h6>
    <table>
         <tr>
             <td rowspan="2" >L1- Operate vessels safely in DP mode with due regard for safety off life at sea and protection of the marine environment</td>
                <td>1.1.1</td>
                <td>1.1.2</td>
                <td>1.1.3</td>
                <td>1.1.4</td>
                <td>1.1.5</td>
                <td>1.1.6</td>
                <td>1.1.7</td>
                <td>1.1.8</td>
                <td>1.1.9</td>
                <td>1.1.10</td>
            </tr>
            <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
    </table>

    <h6>Additional tasks for offshore supply vessels</h6>
    <table>
            <tr>
                <td rowspan="2">M1- Contribute to the safe operation of offshore vessels with due regard for safety of life at sea and protection of the marine environment</td>
                <td>1.1.1</td>
                <td>1.1.2</td>
                <td>1.1.3</td>
                <td>1.1.4</td>
                <td>1.1.5</td>
                <td>1.1.6</td>
                <td>1.1.7</td>
                <td>1.1.8</td>
                <td>1.1.9</td>
                <td>1.1.10</td>
            </tr>
            <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
    </table>
    </div>



        </section>
    );
}

export default Comp_CRB_New